import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  navViewMedia,
  navCloseMedia,
} from 'redux/actions'
import {
  selectedEventInfoDayMediaDisplayed,
  selectedEventMediaId,
  selectedEventMediaType,
} from 'redux/reducers'

import Component from './component'

const mapStateToProps = state => ({
  mediaDisplayed: selectedEventInfoDayMediaDisplayed(state),
  mediaId: selectedEventMediaId(state),
  mediaType: selectedEventMediaType(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      navViewMedia,
      navCloseMedia,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/EventInfo/index.js